import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import MemberStatus from './components/MemberStatus';
import MemberDetails from 'components/holders_list/components/EligibilityComponents/MemberDetails';
import { CTAButton3 } from 'components/_shared/buttons';
import { makeStyles } from '@mui/styles';
import { MemberSearchResult } from 'types';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '32px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '40px'
    }
}));

const iconStyle = {
    backgroundColor: '#E7EFFE',
    border: '2px solid #062D7A',
    color: '#062D7A',
    fontSize: '24px'
};

type ClosedMembershipPopupProps = {
    member: MemberSearchResult;
    reason?: string | null;
    closeButtonText: string;
    handleCloseClick: () => void;
};

const ClosedMembershipPopup: React.FC<ClosedMembershipPopupProps> = ({
    member,
    reason,
    closeButtonText,
    handleCloseClick
}) => {
    const classes = useStyles();

    const memberName = member?.pii_first_name && member?.pii_last_name ? `${member.pii_first_name} ${member.pii_last_name}` : member?.name || '-';
    return (
        <Modal2
            onClose={handleCloseClick}
            additionalStyles={{ iconStyle: iconStyle }}
            iconName=""
            title="Reinstate"
        >
            <div className={classes.body}>
                <MemberStatus
                    photo={member.photo}
                    icon="far fa-exclamation-circle"
                    title={`${memberName} has a closed membership`}
                    subtext={reason || ''}
                    colorType="yellow"
                />
                <MemberDetails member={member} />
                <div className={classes.buttonContainer}>
                    <CTAButton3 onClick={handleCloseClick}>
                        {closeButtonText}
                    </CTAButton3>
                </div>
            </div>
        </Modal2>
    );
};

export default ClosedMembershipPopup;
